<template>
  <div
    class="mx-5 mb-5"
  >
    <v-btn-toggle
      v-model="attachmentTypeId"
      class="d-flex align-center justify-center"
    >
      <btn
        v-for="bucket in filteredAdminBucketTypes"
        :key="bucket.value"
        :label="bucket.title"
        :icon="bucket.icon"
        :value="bucket.value"
        :style="`width:${100 / filteredAdminBucketTypes.length}%`"
        :disabled="disabled"
        @click="attachmentTypeClicked(bucket.value)"
      >
        <v-badge
          v-if="attachmentCount(bucket.value) && bucket.value !== 'visit-dictation'"
          color="primary"
          :content="attachmentCount(bucket.value)"
          inline
        >
          {{ bucket.title }}
        </v-badge>
      </btn>
    </v-btn-toggle>

    <!-- attachment modal -->
    <attachment-modal
      :attachment-modal.sync="attachmentModal"
      :attachment-type-id.sync="attachmentTypeId"
      :attachment-type.sync="attachmentType"
      :encounter-attachments.sync="encounterAttachments"
      :patient-id="patientId"
      :signed="isSigned"
      :from-patient-view="fromPatientView"
    ></attachment-modal>
    <!-- audio recorder modal -->
    <audio-recorder-modal
      :audio-recorder-modal.sync="audioRecorderModal"
      :attachment-type-id.sync="attachmentTypeId"
      :patient-id="patientId"
      :attachment-type.sync="attachmentType"
      :encounter-attachments.sync="encounterAttachments"
      :signed="isSigned"
      @open-wound-mapping-modal="$emit('update:wound-mapping-modal',true)"
    ></audio-recorder-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AttachmentModal from '@/components/notes/encounter/AttachmentModal.vue'
import AudioRecorderModal from '@/components/notes/encounter/AudioRecorderModal.vue'

export default {
  components: { AttachmentModal, AudioRecorderModal },
  props: {
    picsOnly: {
      type: Boolean,
      default: false,
    },
    isSigned: {
      type: [Boolean, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    patientId: {
      type: String,
      default: null,
    },
    encounterAttachments: {
      type: Array,
      default: null,
    },
    woundMappingModal: {
      type: Boolean,
      default: false,
    },
    fromPatientView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      attachmentTypeId: null,
      attachmentModal: false,
      audioRecorderModal: false,
      attachmentType: null,
    }
  },
  computed: {
    ...mapGetters('baseData', ['bucketTypes', 'providerDictationList']),
    ...mapGetters('auth', ['user']),
    isAllowedProviderDictation() {
      return this.user.is_superuser || this.user.is_test_user || this.user.is_beta_tester
    },
    filteredAdminBucketTypes() {
      if (this.fromPatientView) {
        return this.bucketTypes.filter(bucket => bucket.value !== 'images' && bucket.value !== 'visit-dictation')
      }

      return this.isAllowedProviderDictation ? this.bucketTypes : this.bucketTypes.filter(bucket => bucket.value !== 'visit-dictation')
    },
  },
  watch: {
  },
  methods: {
    attachmentCount(bucket) {
      if (!Array.isArray(this.encounterAttachments)) return false

      return this.encounterAttachments.reduce((count, item) => count + (item.attachment_type === bucket), 0)
    },
    attachmentTypeClicked(value) {
      this.attachmentType = value
      this.attachmentTypeId = null

      if (value === 'visit-dictation') {
        this.audioRecorderModal = true
      } else {
        this.attachmentModal = true
      }
    },
  },
}
</script>

<style scoped>
.v-badge {
  font-size: 12px
}
</style>
